var _path, _path2, _path3, _path4, _rect, _path5, _path6, _rect2, _g, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect4, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect5, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenantRepBrokerIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 617 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.193 212C341.089 212 340.193 212.895 340.193 214C340.193 215.105 341.089 216 342.193 216L342.193 212ZM485.898 214L465.898 202.453L465.898 225.547L485.898 214ZM348.181 216C349.286 216 350.181 215.105 350.181 214C350.181 212.895 349.286 212 348.181 212L348.181 216ZM360.156 212C359.052 212 358.156 212.895 358.156 214C358.156 215.105 359.052 216 360.156 216L360.156 212ZM372.132 216C373.236 216 374.132 215.105 374.132 214C374.132 212.895 373.236 212 372.132 212L372.132 216ZM384.107 212C383.003 212 382.107 212.895 382.107 214C382.107 215.105 383.003 216 384.107 216L384.107 212ZM396.083 216C397.187 216 398.083 215.105 398.083 214C398.083 212.895 397.187 212 396.083 212L396.083 216ZM408.058 212C406.953 212 406.058 212.895 406.058 214C406.058 215.105 406.953 216 408.058 216L408.058 212ZM420.033 216C421.138 216 422.033 215.105 422.033 214C422.033 212.895 421.138 212 420.033 212L420.033 216ZM432.009 212C430.904 212 430.009 212.895 430.009 214C430.009 215.105 430.904 216 432.009 216L432.009 212ZM443.984 216C445.089 216 445.984 215.105 445.984 214C445.984 212.895 445.089 212 443.984 212L443.984 216ZM455.959 212C454.855 212 453.959 212.895 453.959 214C453.959 215.105 454.855 216 455.959 216L455.959 212ZM467.935 216C469.039 216 469.935 215.105 469.935 214C469.935 212.895 469.039 212 467.935 212L467.935 216ZM479.91 212C478.806 212 477.91 212.895 477.91 214C477.91 215.105 478.806 216 479.91 216L479.91 212ZM342.193 216L348.181 216L348.181 212L342.193 212L342.193 216ZM360.156 216L372.132 216L372.132 212L360.156 212L360.156 216ZM384.107 216L396.083 216L396.083 212L384.107 212L384.107 216ZM408.058 216L420.033 216L420.033 212L408.058 212L408.058 216ZM432.009 216L443.984 216L443.984 212L432.009 212L432.009 216ZM455.959 216L467.935 216L467.935 212L455.959 212L455.959 216Z",
    fill: "#A6C8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.278 212.56C380.633 213.456 380.88 214.638 381.831 215.2C382.782 215.762 384.077 215.49 384.722 214.594L381.278 212.56ZM442.546 130.879L420.918 141.236L440.802 152.982L442.546 130.879ZM388.444 209.425C389.089 208.529 388.841 207.347 387.89 206.785C386.939 206.223 385.645 206.495 385 207.391L388.444 209.425ZM392.443 197.054C391.797 197.95 392.045 199.132 392.996 199.694C393.947 200.256 395.241 199.985 395.887 199.088L392.443 197.054ZM403.33 188.751C403.976 187.855 403.728 186.672 402.777 186.111C401.826 185.549 400.532 185.82 399.886 186.717L403.33 188.751ZM407.329 176.379C406.684 177.276 406.932 178.458 407.883 179.02C408.834 179.581 410.128 179.31 410.773 178.414L407.329 176.379ZM418.217 168.076C418.862 167.18 418.614 165.998 417.663 165.436C416.712 164.874 415.418 165.146 414.773 166.042L418.217 168.076ZM422.216 155.705C421.57 156.601 421.818 157.783 422.769 158.345C423.72 158.907 425.015 158.636 425.66 157.739L422.216 155.705ZM433.103 147.402C433.749 146.505 433.501 145.323 432.55 144.762C431.599 144.2 430.305 144.471 429.659 145.367L433.103 147.402ZM437.102 135.03C436.457 135.927 436.705 137.109 437.656 137.67C438.607 138.232 439.901 137.961 440.546 137.065L437.102 135.03ZM384.722 214.594L388.444 209.425L385 207.391L381.278 212.56L384.722 214.594ZM395.887 199.088L403.33 188.751L399.886 186.717L392.443 197.054L395.887 199.088ZM410.773 178.414L418.217 168.076L414.773 166.042L407.329 176.379L410.773 178.414ZM425.66 157.739L433.103 147.402L429.659 145.367L422.216 155.705L425.66 157.739Z",
    fill: "#A6C8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.278 214.594C380.633 213.698 380.88 212.516 381.831 211.954C382.782 211.392 384.077 211.663 384.722 212.56L381.278 214.594ZM442.546 296.275L420.918 285.917L440.802 274.172L442.546 296.275ZM388.444 217.728C389.089 218.625 388.841 219.807 387.89 220.369C386.939 220.93 385.645 220.659 385 219.763L388.444 217.728ZM392.443 230.1C391.797 229.204 392.045 228.022 392.996 227.46C393.947 226.898 395.241 227.169 395.887 228.066L392.443 230.1ZM403.33 238.403C403.976 239.299 403.728 240.481 402.777 241.043C401.826 241.605 400.532 241.334 399.886 240.437L403.33 238.403ZM407.329 250.775C406.684 249.878 406.932 248.696 407.883 248.134C408.834 247.573 410.128 247.844 410.773 248.74L407.329 250.775ZM418.217 259.077C418.862 259.974 418.614 261.156 417.663 261.718C416.712 262.279 415.418 262.008 414.773 261.112L418.217 259.077ZM422.216 271.449C421.57 270.553 421.818 269.371 422.769 268.809C423.72 268.247 425.015 268.518 425.66 269.415L422.216 271.449ZM433.103 279.752C433.749 280.648 433.501 281.83 432.55 282.392C431.599 282.954 430.305 282.683 429.659 281.786L433.103 279.752ZM437.102 292.124C436.457 291.227 436.705 290.045 437.656 289.483C438.607 288.922 439.901 289.193 440.546 290.089L437.102 292.124ZM384.722 212.56L388.444 217.728L385 219.763L381.278 214.594L384.722 212.56ZM395.887 228.066L403.33 238.403L399.886 240.437L392.443 230.1L395.887 228.066ZM410.773 248.74L418.217 259.077L414.773 261.112L407.329 250.775L410.773 248.74ZM425.66 269.415L433.103 279.752L429.659 281.786L422.216 271.449L425.66 269.415Z",
    fill: "#A6C8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.568 212C132.464 212 131.568 212.895 131.568 214C131.568 215.105 132.464 216 133.568 216L133.568 212ZM209.568 214L189.568 202.453L189.568 225.547L209.568 214ZM139.902 216C141.006 216 141.902 215.105 141.902 214C141.902 212.895 141.006 212 139.902 212L139.902 216ZM152.568 212C151.464 212 150.568 212.895 150.568 214C150.568 215.105 151.464 216 152.568 216L152.568 212ZM165.235 216C166.34 216 167.235 215.105 167.235 214C167.235 212.895 166.34 212 165.235 212L165.235 216ZM177.902 212C176.797 212 175.902 212.895 175.902 214C175.902 215.105 176.797 216 177.902 216L177.902 212ZM190.568 216C191.673 216 192.568 215.105 192.568 214C192.568 212.895 191.673 212 190.568 212L190.568 216ZM203.235 212C202.13 212 201.235 212.895 201.235 214C201.235 215.105 202.13 216 203.235 216L203.235 212ZM133.568 216L139.902 216L139.902 212L133.568 212L133.568 216ZM152.568 216L165.235 216L165.235 212L152.568 212L152.568 216ZM177.902 216L190.568 216L190.568 212L177.902 212L177.902 216Z",
    fill: "#A6C8FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 148.138,
    width: 134,
    height: 134,
    rx: 67,
    fill: "#F2F8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9941 190.471C59.2622 190.471 52.9941 196.739 52.9941 204.471C52.9941 212.203 59.2622 218.471 66.9941 218.471C74.7261 218.471 80.9941 212.203 80.9941 204.471C80.9941 196.739 74.7261 190.471 66.9941 190.471ZM48.9941 204.471C48.9941 194.53 57.053 186.471 66.9941 186.471C76.9353 186.471 84.9941 194.53 84.9941 204.471C84.9941 214.412 76.9353 222.471 66.9941 222.471C57.053 222.471 48.9941 214.412 48.9941 204.471Z",
    fill: "url(#paint0_linear_295_12424)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.841 235.474C45.879 237.598 44.9941 240.129 44.9941 241.804C44.9941 242.909 44.0987 243.804 42.9941 243.804C41.8896 243.804 40.9941 242.909 40.9941 241.804C40.9941 238.979 42.3625 235.51 44.9023 232.76C47.497 229.95 51.3902 227.804 56.4941 227.804H77.4941C82.6011 227.804 86.4945 229.95 89.0887 232.76C91.628 235.511 92.9941 238.98 92.9941 241.804C92.9941 242.909 92.0987 243.804 90.9941 243.804C89.8896 243.804 88.9941 242.909 88.9941 241.804C88.9941 240.129 88.1103 237.597 86.1495 235.473C84.2438 233.409 81.3872 231.804 77.4941 231.804H56.4941C52.6047 231.804 49.7479 233.409 47.841 235.474Z",
    fill: "url(#paint1_linear_295_12424)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 148.138,
    width: 134,
    height: 134,
    rx: 67,
    fill: "#F2F8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_12424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.077 195.625C275.244 195.625 271.327 199.543 271.327 204.375C271.327 209.208 275.244 213.125 280.077 213.125C284.909 213.125 288.827 209.208 288.827 204.375C288.827 199.543 284.909 195.625 280.077 195.625ZM266.952 204.375C266.952 197.126 272.828 191.25 280.077 191.25C287.326 191.25 293.202 197.126 293.202 204.375C293.202 211.624 287.326 217.5 280.077 217.5C272.828 217.5 266.952 211.624 266.952 204.375Z",
    fill: "url(#paint2_linear_295_12424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.954 238.783C306.232 238.935 306.536 239.011 306.839 239.011C307.234 239.011 307.626 238.883 307.958 238.632C308.544 238.187 308.837 237.435 308.715 236.69L307.752 230.835C307.658 230.261 307.843 229.676 308.251 229.261L312.315 225.128C312.833 224.601 313.02 223.812 312.796 223.093C312.572 222.374 311.977 221.851 311.26 221.742L305.707 220.9C305.108 220.809 304.592 220.425 304.333 219.877L301.835 214.597C301.515 213.919 300.853 213.49 300.129 213.49C299.405 213.49 298.743 213.919 298.423 214.597L295.925 219.877C295.666 220.425 295.151 220.809 294.551 220.9L288.998 221.742C288.477 221.821 288.021 222.119 287.724 222.551C287.612 222.714 287.523 222.896 287.462 223.093C287.238 223.812 287.425 224.601 287.943 225.128L292.007 229.261C292.187 229.445 292.324 229.662 292.412 229.896C292.524 230.192 292.558 230.515 292.506 230.835L291.543 236.69C291.421 237.435 291.714 238.187 292.3 238.632C292.632 238.883 293.024 239.011 293.419 239.011C293.722 239.011 294.026 238.935 294.304 238.783L299.252 236.068C299.798 235.769 300.46 235.769 301.006 236.068L305.954 238.783Z",
    fill: "url(#paint3_linear_295_12424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.477 236.838C261.477 233.509 265.424 226.921 274.055 226.921H287.149C285.97 225.722 285.179 224.291 285.721 222.551L274.055 222.546C263.013 222.546 257.102 231.088 257.102 236.838C257.102 238.046 258.081 239.025 259.289 239.025C260.497 239.025 261.477 238.046 261.477 236.838Z",
    fill: "url(#paint4_linear_295_12424)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    width: 122,
    height: 122,
    rx: 61,
    fill: "#F2F8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.334 53.6667C501.334 52.5621 502.229 51.6667 503.334 51.6667H510.001C511.105 51.6667 512.001 52.5621 512.001 53.6667C512.001 54.7712 511.105 55.6667 510.001 55.6667H503.334C502.229 55.6667 501.334 54.7712 501.334 53.6667Z",
    fill: "url(#paint5_linear_295_12424)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.001 53.6667C488.001 52.5621 488.896 51.6667 490.001 51.6667H496.667C497.772 51.6667 498.667 52.5621 498.667 53.6667C498.667 54.7712 497.772 55.6667 496.667 55.6667H490.001C488.896 55.6667 488.001 54.7712 488.001 53.6667Z",
    fill: "url(#paint6_linear_295_12424)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.334 60.3333C501.334 59.2288 502.229 58.3333 503.334 58.3333H510.001C511.105 58.3333 512.001 59.2288 512.001 60.3333C512.001 61.4379 511.105 62.3333 510.001 62.3333H503.334C502.229 62.3333 501.334 61.4379 501.334 60.3333Z",
    fill: "url(#paint7_linear_295_12424)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.001 60.3333C488.001 59.2288 488.896 58.3333 490.001 58.3333H496.667C497.772 58.3333 498.667 59.2288 498.667 60.3333C498.667 61.4379 497.772 62.3333 496.667 62.3333H490.001C488.896 62.3333 488.001 61.4379 488.001 60.3333Z",
    fill: "url(#paint8_linear_295_12424)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.334 47.5312C501.334 46.4267 502.229 45.5312 503.334 45.5312H510.001C511.105 45.5312 512.001 46.4267 512.001 47.5312C512.001 48.6358 511.105 49.5312 510.001 49.5312H503.334C502.229 49.5312 501.334 48.6358 501.334 47.5312Z",
    fill: "url(#paint9_linear_295_12424)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.334 35.8127C515.334 35.3276 514.832 35.0049 514.391 35.206L485.058 48.5709C484.82 48.6792 484.667 48.9164 484.667 49.1776V65H480.667V49.1776C480.667 47.3491 481.735 45.6891 483.399 44.9309L512.732 31.5661C515.823 30.1581 519.334 32.4169 519.334 35.8127V86.3333H515.334V35.8127Z",
    fill: "url(#paint10_linear_295_12424)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.667 67.0015C476.667 66.5821 477.05 66.2668 477.462 66.3472L506.795 72.075C507.108 72.1361 507.334 72.4104 507.334 72.7293V86.3333H511.334V72.7293C511.334 70.4968 509.753 68.577 507.562 68.1492L478.228 62.4214C475.347 61.8586 472.667 64.0653 472.667 67.0015V86.3333H476.667V67.0015Z",
    fill: "url(#paint11_linear_295_12424)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.334 88.3333C469.334 87.2288 470.229 86.3333 471.334 86.3333H520.667C521.772 86.3333 522.667 87.2288 522.667 88.3333C522.667 89.4379 521.772 90.3333 520.667 90.3333H471.334C470.229 90.3333 469.334 89.4379 469.334 88.3333Z",
    fill: "url(#paint12_linear_295_12424)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.001 79.6667C486.001 77.0893 488.09 75 490.667 75H493.334C495.911 75 498.001 77.0893 498.001 79.6667V86.3333H494.001V79.6667C494.001 79.2985 493.702 79 493.334 79H490.667C490.299 79 490.001 79.2985 490.001 79.6667V86.3333H486.001V79.6667Z",
    fill: "url(#paint13_linear_295_12424)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 495,
    y: 146,
    width: 122,
    height: 122,
    rx: 61,
    fill: "#F2F8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.334 199.667C561.334 198.562 562.229 197.667 563.334 197.667H570.001C571.105 197.667 572.001 198.562 572.001 199.667C572.001 200.771 571.105 201.667 570.001 201.667H563.334C562.229 201.667 561.334 200.771 561.334 199.667Z",
    fill: "url(#paint14_linear_295_12424)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.001 199.667C548.001 198.562 548.896 197.667 550.001 197.667H556.667C557.772 197.667 558.667 198.562 558.667 199.667C558.667 200.771 557.772 201.667 556.667 201.667H550.001C548.896 201.667 548.001 200.771 548.001 199.667Z",
    fill: "url(#paint15_linear_295_12424)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.334 206.333C561.334 205.229 562.229 204.333 563.334 204.333H570.001C571.105 204.333 572.001 205.229 572.001 206.333C572.001 207.438 571.105 208.333 570.001 208.333H563.334C562.229 208.333 561.334 207.438 561.334 206.333Z",
    fill: "url(#paint16_linear_295_12424)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.001 206.333C548.001 205.229 548.896 204.333 550.001 204.333H556.667C557.772 204.333 558.667 205.229 558.667 206.333C558.667 207.438 557.772 208.333 556.667 208.333H550.001C548.896 208.333 548.001 207.438 548.001 206.333Z",
    fill: "url(#paint17_linear_295_12424)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.334 193.531C561.334 192.427 562.229 191.531 563.334 191.531H570.001C571.105 191.531 572.001 192.427 572.001 193.531C572.001 194.636 571.105 195.531 570.001 195.531H563.334C562.229 195.531 561.334 194.636 561.334 193.531Z",
    fill: "url(#paint18_linear_295_12424)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.334 181.813C575.334 181.328 574.832 181.005 574.391 181.206L545.058 194.571C544.82 194.679 544.667 194.916 544.667 195.178V211H540.667V195.178C540.667 193.349 541.735 191.689 543.399 190.931L572.732 177.566C575.823 176.158 579.334 178.417 579.334 181.813V232.333H575.334V181.813Z",
    fill: "url(#paint19_linear_295_12424)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.667 213.002C536.667 212.582 537.05 212.267 537.462 212.347L566.795 218.075C567.108 218.136 567.334 218.41 567.334 218.729V232.333H571.334V218.729C571.334 216.497 569.753 214.577 567.562 214.149L538.228 208.421C535.347 207.859 532.667 210.065 532.667 213.002V232.333H536.667V213.002Z",
    fill: "url(#paint20_linear_295_12424)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529.334 234.333C529.334 233.229 530.229 232.333 531.334 232.333H580.667C581.772 232.333 582.667 233.229 582.667 234.333C582.667 235.438 581.772 236.333 580.667 236.333H531.334C530.229 236.333 529.334 235.438 529.334 234.333Z",
    fill: "url(#paint21_linear_295_12424)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.001 225.667C546.001 223.089 548.09 221 550.667 221H553.334C555.911 221 558.001 223.089 558.001 225.667V232.333H554.001V225.667C554.001 225.298 553.702 225 553.334 225H550.667C550.299 225 550.001 225.298 550.001 225.667V232.333H546.001V225.667Z",
    fill: "url(#paint22_linear_295_12424)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 292,
    width: 122,
    height: 122,
    rx: 61,
    fill: "#F2F8FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.334 345.667C501.334 344.562 502.229 343.667 503.334 343.667H510.001C511.105 343.667 512.001 344.562 512.001 345.667C512.001 346.771 511.105 347.667 510.001 347.667H503.334C502.229 347.667 501.334 346.771 501.334 345.667Z",
    fill: "url(#paint23_linear_295_12424)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.001 345.667C488.001 344.562 488.896 343.667 490.001 343.667H496.667C497.772 343.667 498.667 344.562 498.667 345.667C498.667 346.771 497.772 347.667 496.667 347.667H490.001C488.896 347.667 488.001 346.771 488.001 345.667Z",
    fill: "url(#paint24_linear_295_12424)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.334 352.333C501.334 351.229 502.229 350.333 503.334 350.333H510.001C511.105 350.333 512.001 351.229 512.001 352.333C512.001 353.438 511.105 354.333 510.001 354.333H503.334C502.229 354.333 501.334 353.438 501.334 352.333Z",
    fill: "url(#paint25_linear_295_12424)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.001 352.333C488.001 351.229 488.896 350.333 490.001 350.333H496.667C497.772 350.333 498.667 351.229 498.667 352.333C498.667 353.438 497.772 354.333 496.667 354.333H490.001C488.896 354.333 488.001 353.438 488.001 352.333Z",
    fill: "url(#paint26_linear_295_12424)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.334 339.531C501.334 338.427 502.229 337.531 503.334 337.531H510.001C511.105 337.531 512.001 338.427 512.001 339.531C512.001 340.636 511.105 341.531 510.001 341.531H503.334C502.229 341.531 501.334 340.636 501.334 339.531Z",
    fill: "url(#paint27_linear_295_12424)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.334 327.813C515.334 327.328 514.832 327.005 514.391 327.206L485.058 340.571C484.82 340.679 484.667 340.916 484.667 341.178V357H480.667V341.178C480.667 339.349 481.735 337.689 483.399 336.931L512.732 323.566C515.823 322.158 519.334 324.417 519.334 327.813V378.333H515.334V327.813Z",
    fill: "url(#paint28_linear_295_12424)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.667 359.002C476.667 358.582 477.05 358.267 477.462 358.347L506.795 364.075C507.108 364.136 507.334 364.41 507.334 364.729V378.333H511.334V364.729C511.334 362.497 509.753 360.577 507.562 360.149L478.228 354.421C475.347 353.859 472.667 356.065 472.667 359.002V378.333H476.667V359.002Z",
    fill: "url(#paint29_linear_295_12424)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.334 380.333C469.334 379.229 470.229 378.333 471.334 378.333H520.667C521.772 378.333 522.667 379.229 522.667 380.333C522.667 381.438 521.772 382.333 520.667 382.333H471.334C470.229 382.333 469.334 381.438 469.334 380.333Z",
    fill: "url(#paint30_linear_295_12424)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.001 371.667C486.001 369.089 488.09 367 490.667 367H493.334C495.911 367 498.001 369.089 498.001 371.667V378.333H494.001V371.667C494.001 371.298 493.702 371 493.334 371H490.667C490.299 371 490.001 371.298 490.001 371.667V378.333H486.001V371.667Z",
    fill: "url(#paint31_linear_295_12424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_12424",
    x1: 87.1507,
    y1: -193.043,
    x2: 188.967,
    y2: -184.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_12424",
    x1: 87.1507,
    y1: -193.043,
    x2: 188.967,
    y2: -184.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_295_12424",
    x1: 306.62,
    y1: -124.993,
    x2: 415.408,
    y2: -113.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_295_12424",
    x1: 306.62,
    y1: -124.993,
    x2: 415.408,
    y2: -113.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_295_12424",
    x1: 306.62,
    y1: -124.993,
    x2: 415.408,
    y2: -113.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_295_12424",
    x1: 516.674,
    y1: -360.681,
    x2: 621.11,
    y2: -352.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_295_12424",
    x1: 576.674,
    y1: -214.681,
    x2: 681.11,
    y2: -206.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_295_12424",
    x1: 516.674,
    y1: -68.681,
    x2: 621.11,
    y2: -60.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_12424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(250 180.138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantRepBrokerIllustration);
export default __webpack_public_path__ + "static/media/tenant-rep-broker-illustration.f67b2babe41ac32a1af1f588235ed581.svg";
export { ForwardRef as ReactComponent };